import {
  GET_SPECIALITY_BY_STYLE_REQUEST,
  GET_SPECIALITY_BY_STYLE_SUCCESS,
  GET_SPECIALITY_BY_STYLE_ERROR
} from "../actions/types";

export const SpecialityByStyle = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SPECIALITY_BY_STYLE_REQUEST:
      return {
        loading: true,
      };
    case GET_SPECIALITY_BY_STYLE_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_SPECIALITY_BY_STYLE_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
